export default "__VITE_ASSET__CN6q3FjZ__"